import React, { useState } from "react";

export default function PrivacyPolicy() {
    const [lang, setLang] = useState("vi");

    const toggleLang = () => setLang(lang === "vi" ? "en" : "vi");

    const content = {
        vi: {
            title: "Chính sách quyền riêng tư & Điều khoản sử dụng",
            intro:
                "Ứng dụng Nhơn Trạch Today (thuộc sở hữu bởi Công ty HNC) cam kết bảo vệ quyền riêng tư và dữ liệu cá nhân của người dùng.",
            sections: [
                {
                    title: "1. Giới thiệu",
                    body: "Chính sách này mô tả cách chúng tôi thu thập, sử dụng và bảo vệ thông tin của bạn khi sử dụng ứng dụng hoặc website.",
                },
                {
                    title: "2. Thông tin thu thập",
                    body: "Chúng tôi có thể thu thập thông tin cá nhân (tên, email), dữ liệu sử dụng (IP, thiết bị, thời gian truy cập) và vị trí (nếu bạn cho phép).",
                },
                {
                    title: "3. Mục đích sử dụng",
                    body: "Thông tin được sử dụng để cung cấp dịch vụ, cải thiện trải nghiệm người dùng, gửi thông báo và phân tích phát triển sản phẩm.",
                },
                {
                    title: "4. Chia sẻ dữ liệu",
                    body: "Chúng tôi không chia sẻ dữ liệu cá nhân cho bên thứ ba, trừ khi có yêu cầu pháp lý hoặc cần thiết để vận hành dịch vụ.",
                },
                {
                    title: "5. Quyền của người dùng",
                    body: "Bạn có quyền truy cập, chỉnh sửa, xóa dữ liệu hoặc yêu cầu chúng tôi ngừng sử dụng thông tin cá nhân của bạn.",
                },
                {
                    title: "6. Liên hệ",
                    body: "Nhon Trach Today – Email: nhontrachtoday@gmail.com – Facebook: facebook.com/nhontrach.today2024",
                },
            ],
        },
        en: {
            title: "Privacy Policy & Terms of Use",
            intro:
                "Nhơn Trạch Today (owned and operated by HNC Company) is committed to protecting your privacy and personal data.",
            sections: [
                {
                    title: "1. Introduction",
                    body: "This policy explains how we collect, use, and protect your information when using our app or website.",
                },
                {
                    title: "2. Information Collected",
                    body: "We may collect personal data (name, email), usage data (IP, device, access time), and location (if permitted).",
                },
                {
                    title: "3. Purpose of Use",
                    body: "Your information is used to provide services, improve user experience, send notifications, and analyze development data.",
                },
                {
                    title: "4. Data Sharing",
                    body: "We do not share or sell user data to third parties unless required by law or necessary to operate our services.",
                },
                {
                    title: "5. User Rights",
                    body: "You have the right to access, edit, delete, or request us to stop using your personal data.",
                },
                {
                    title: "6. Contact",
                    body: "Nhon Trach Today – Email: nhontrachtoday@gmail.com – Facebook: facebook.com/nhontrach.today2024",
                },
            ],
        },
    };

    const t = content[lang];

    return (
        <div className="max-w-3xl mx-auto bg-white shadow-lg rounded-2xl p-8">
            <div className="flex justify-between items-center mb-6">
                <h1 className="text-2xl font-bold text-vietnam-primary">{t.title}</h1>
                <button
                    onClick={toggleLang}
                    className="px-4 py-2 border rounded-lg text-sm hover:bg-red-50 transition"
                >
                    {lang === "vi" ? "🇬🇧 English" : "🇻🇳 Tiếng Việt"}
                </button>
            </div>

            <p className="text-gray-700 mb-6">{t.intro}</p>

            <div className="space-y-5">
                {t.sections.map((sec, i) => (
                    <div key={i}>
                        <h2 className="text-lg font-semibold text-gray-800 mb-2">
                            {sec.title}
                        </h2>
                        <p className="text-gray-600 leading-relaxed">{sec.body}</p>
                    </div>
                ))}
            </div>

            <div className="mt-8 border-t pt-4 text-sm text-gray-500">
                <p>© {new Date().getFullYear()} HNC. Your Trusted Technology Partner</p>
                <p>Website: https://hnc-tech.web.app/</p>
            </div>
        </div>
    );
}
